import { PropsWithChildren } from 'react';
import { ConfigProvider } from 'antd';
import ruRu from 'antd/lib/locale/ru_RU';
import { observer } from 'mobx-react-lite';
import moment from 'moment';

// import 'moment/locale/ru';
import './styles.less';

import { ApiClientProvider } from './common/api/api-client.provider';
import { useInstance } from './libs/use-instance';
import {
  AuthStatusProvider,
  AuthStatusStore,
} from './railways/domains/auth/features/auth-status';

moment.locale('ru');
moment.defaultFormat = 'HH:mm DD.MM.YYYY';

export const AppConfigProvider = observer(({ children }: PropsWithChildren) => {
  const authStatusStore = useInstance(() => new AuthStatusStore());
  return (
    <ApiClientProvider>
      <AuthStatusProvider value={authStatusStore}>
        <ConfigProvider locale={ruRu}>{children}</ConfigProvider>
      </AuthStatusProvider>
    </ApiClientProvider>
  );
});
